import Typography from '@material-ui/core/Typography';
import React from 'react';

interface IProps {
  status: 'approved' | 'reproved';
  message: string;
}

const ThankyouPage = ({ status, message }: IProps) => {
  return (
    <>
      {message && <Typography variant='subtitle1'>{message}</Typography>}
      {status === 'reproved' && !message && (
        <Typography variant='subtitle1'>
          Agradecemos pelo seu retorno, nossa equipe de suporte foi notificada e em breve analisará sua solicitação!
        </Typography>
      )}
      {status === 'approved' && !message && (
        <Typography variant='subtitle1'>Agradecemos pela aprovação, isso é muito importante para nós!!</Typography>
      )}
    </>
  );
};

export default ThankyouPage;
